import z from "zod";
import { ZodDateString } from "../zod-types/zod-date-string";

export const crewDefinitionTicketAssignmentSchema = z
	.object({
		ticketId: z.uuid(),
		/**
		 * Both ends are mandatory. A crew is scheduled onto a ticket for a stretch of days, and an
		 * open-ended stretch would claim the crew for ever on a ticket that ends.
		 */
		startDate: ZodDateString,
		endDate: ZodDateString,
	})
	.transform((value) => {
		// Dates the wrong way round are swapped rather than refused, the same reading the ticket's
		// own window takes: the two inputs are a span, and which one was filled first is not
		// information worth an error.
		if (value.endDate < value.startDate) {
			const _startDate = value.startDate;
			value.startDate = value.endDate;
			value.endDate = _startDate;
		}
		return value;
	});

export type CrewDefinitionTicketAssignmentFormSchema = z.infer<
	typeof crewDefinitionTicketAssignmentSchema
>;
